import { IResponse, IResponseList, IResponsePagination } from '@/types/common';
import {
  ICreateCompanyRequest,
  IGetListCompanyRequest,
  IUpdateCompanyRequest,
} from '@/types/request/company';
import {
  IGetDetailCompanyResponse,
  IGetListCompanyResponse,
} from '@/types/response/company';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';
import type { ICheckInviteCodeRequest } from '@/types/request/company';
import type { ICheckInviteCodeResponse } from '@/types/response/company';

class Company {
  create = (body: ICreateCompanyRequest): Promise<IResponse<any>> => {
    return axiosClient.post(ENDPOINT.COMPANY.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<IGetDetailCompanyResponse>> => {
    return axiosClient.get(ENDPOINT.COMPANY.GET_DETAIL.replace(':id', String(id)));
  };

  update = (
    id: number,
    body: IUpdateCompanyRequest,
  ): Promise<IResponse<any>> => {
    return axiosClient.put(ENDPOINT.COMPANY.UPDATE.replace(':id', String(id)), body);
  };

  getList = (
    params: IGetListCompanyRequest,
  ): Promise<IResponsePagination<IGetListCompanyResponse>> => {
    return axiosClient.get(ENDPOINT.COMPANY.GET_LIST, { params });
  };

  getArticles = (
    companyId?: number,
  ): Promise<IResponseList<{ id: number; name: string }>> => {
    return axiosClient.get(ENDPOINT.COMPANY.GET_ARTICLES, {
      params: companyId ? { companyId } : undefined,
    });
  };

  checkInviteCode = (
    body: ICheckInviteCodeRequest,
  ): Promise<IResponse<ICheckInviteCodeResponse>> => {
    return axiosClient.post(ENDPOINT.COMPANY.CHECK_INVITE_CODE, body);
  };

  changeStatus = (id: number): Promise<IResponse<any>> => {
    return axiosClient.put(
      ENDPOINT.COMPANY.CHANGE_STATUS.replace(':id', String(id)),
      {},
    );
  };
}

export const CompanyService = new Company();
